import React from "react";
import { Link } from "react-router-dom";

const leaders = [
  {
    name: "IRINA ABDRABBOH",
    role: "Founder & CEO",
    image: "/images/irina.jpeg",
    alt: "Irina Abdrabboh - Founder and CEO",
    description:
      "Service-Disabled Combat Veteran with executive leadership overseeing strategy and federal partnerships.",
    imageClassName: "object-cover",
  },
  {
    name: "OMAR ELOUIZI",
    role: "Co-Founder & COO",
    image: "/images/omar.jpeg",
    alt: "Omar Elouizi - Co-Founder and COO",
    description:
      "Leads operational coordination and supports contract execution and performance delivery.",
    imageClassName: "object-cover object-top",
  },
];

const LeadershipPreview = () => {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-4 py-1 bg-[#C5A047]/10 text-[#C5A047] text-sm font-semibold rounded-full mb-3">
            LEADERSHIP
          </span>

          <h2 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Executive Leadership
          </h2>

          <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            Experienced leadership driving mission-critical operations and federal partnerships.
          </p>
        </div>

        {/* Leadership cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {leaders.map((leader) => (
            <div
              key={leader.name}
              className="group bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-8 md:p-10 text-center"
            >
              <div className="w-28 h-28 md:w-32 md:h-32 mx-auto mb-5 overflow-hidden rounded-full shadow-md">
                <img
                  src={leader.image}
                  alt={leader.alt}
                  className={`w-full h-full ${leader.imageClassName} group-hover:scale-105 transition-transform duration-300`}
                  loading="lazy"
                />
              </div>

              <h3 className="text-lg md:text-xl font-bold tracking-wide text-[#2C3E50] mb-1">
                {leader.name}
              </h3>

              <div className="text-[#C5A047] font-medium mb-4">
                {leader.role}
              </div>

              <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-sm mx-auto">
                {leader.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/leadership"
            className="inline-flex items-center text-[#C5A047] font-semibold hover:text-[#D4AF37] transition-colors"
          >
            View Full Leadership Team
            <svg
              className="ml-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LeadershipPreview;